var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col gap-5 bg-slate-200",
      attrs: { "data-id": _vm.panelId }
    },
    [
      _c(
        "div",
        {
          staticClass: "px-6 py-5 bg-pure-white",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center justify-between gap-6 mb-1",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody2", {
                staticClass: "truncate",
                attrs: {
                  "data-id": _vm.panelId,
                  text: _vm.target.curriculum_name
                }
              }),
              _vm._v(" "),
              _c("BlIcon", { attrs: { icon: "close", clickable: true } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4", attrs: { "data-id": _vm.panelId } },
            [
              _c("BlTextSubtitle1", {
                attrs: { "data-id": _vm.panelId, text: _vm.target.name }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4", attrs: { "data-id": _vm.panelId } },
            [
              _c("BlTextBody2", {
                staticClass: "whitespace-pre-line",
                attrs: { "data-id": _vm.panelId, text: _vm.target.description }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex gap-2 mb-2",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlIcon", {
                staticClass: "w-4 h-4",
                attrs: {
                  "data-id": _vm.panelId,
                  icon: "document-normal",
                  color: "slate-6"
                }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  "data-id": _vm.panelId,
                  text: _vm.targetTypes[_vm.target.type]
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex items-start gap-2 mb-2",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlIcon", {
                staticClass: "w-4 mt-0.5",
                attrs: {
                  "data-id": _vm.panelId,
                  icon: "goal",
                  color: "slate-6"
                }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  "data-id": _vm.panelId,
                  text: _vm.generateSuccessMetric(_vm.target)
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.target.type.includes("Percentage")
            ? _c(
                "div",
                {
                  staticClass: "flex gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: {
                      "data-id": _vm.panelId,
                      icon: "tick-square",
                      color: "slate-6"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.target.number_of_trial + " trial(s)"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.target.type.includes("Pir")
            ? _c(
                "div",
                {
                  staticClass: "flex gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-5",
                    attrs: {
                      "data-id": _vm.panelId,
                      icon: "timer",
                      color: "slate-6"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.target.duration + " minute(s)"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.target.probing_enable
        ? _c(
            "div",
            {
              staticClass: "px-6 py-5 bg-pure-white",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                { staticClass: "mb-1", attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextSubtitle2", {
                    attrs: { "data-id": _vm.panelId, text: "Probing" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-4", attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text:
                        "Probing can be employed to assess a skill at various stages of your therapy."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex items-start gap-2 mb-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 mt-0.5",
                    attrs: {
                      "data-id": _vm.panelId,
                      icon: "goal",
                      color: "slate-6"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "≥ " + _vm.target.probing_goal + "%"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: {
                      "data-id": _vm.panelId,
                      icon: "tick-square",
                      color: "slate-6"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.target.probing_number_of_trial + " trial(s)"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Prompting")
        ? _c(
            "div",
            {
              staticClass: "px-6 py-5 bg-pure-white",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                { staticClass: "mb-1", attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextSubtitle2", {
                    attrs: { "data-id": _vm.panelId, text: "Prompting" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-4", attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextBody2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Here are the prompts used in this target:"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4",
                  attrs: { "data-id": _vm.panelId }
                },
                _vm._l(_vm.target.prompts, function(prompt) {
                  return _c(
                    "div",
                    {
                      key: prompt.id,
                      staticClass: "flex items-center h-6 gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      prompt.shape && prompt.color
                        ? _c("BlIcon", {
                            staticClass: "w-5",
                            attrs: {
                              "data-id": _vm.panelId,
                              icon: "prompt-" + prompt.shape,
                              color: prompt.color
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { "data-id": _vm.panelId, text: prompt.name }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.actionRecommendation
        ? _c(
            "div",
            {
              staticClass: "px-6 py-5 bg-pure-white",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center gap-2 mb-4",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "p-1 bg-orange-300",
                      style: { borderRadius: "4px" },
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-5 h-5",
                        attrs: { "data-id": _vm.panelId, icon: "tooltip" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextSubtitle2", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Action recommendations"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "p-4 border rounded bg-slate-100 border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-4 space-y-1",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Passing success metric"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex flex-wrap items-center gap-2",
                          attrs: { "data-id": _vm.panelId }
                        },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              "data-id": _vm.panelId,
                              text: "Updating the current target's status from"
                            }
                          }),
                          _vm._v(" "),
                          _c("StatusChip", {
                            staticClass: "text-xs",
                            attrs: {
                              "data-id": _vm.panelId,
                              status: "in_progress"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: { "data-id": _vm.panelId, text: "to" }
                          }),
                          _vm._v(" "),
                          _c("StatusChip", {
                            staticClass: "text-xs",
                            attrs: {
                              "data-id": _vm.panelId,
                              status: "mastered"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.actionRecommendation.total_success === null &&
                  _vm.actionRecommendation.consecutive_success === null
                    ? _c(
                        "div",
                        { attrs: { "data-id": _vm.panelId } },
                        [
                          _c("BlTextBody2", {
                            staticClass: "italic",
                            attrs: {
                              "data-id": _vm.panelId,
                              text:
                                "Currently, no action has been set for this recommendation."
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "pl-6 space-y-4",
                          attrs: { "data-id": _vm.panelId }
                        },
                        [
                          _vm.actionRecommendation.total_success !== null
                            ? _c(
                                "div",
                                {
                                  staticClass: "space-y-1",
                                  attrs: { "data-id": _vm.panelId }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex items-center gap-2",
                                      attrs: { "data-id": _vm.panelId }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "Total success"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-wrap items-center gap-1",
                                      attrs: { "data-id": _vm.panelId }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "Receive a recommendation after"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "completing"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "font-bold",
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text:
                                            "at least " +
                                            _vm.actionRecommendation
                                              .total_success
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "successful"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "session(s)."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.actionRecommendation.consecutive_success !== null
                            ? _c(
                                "div",
                                {
                                  staticClass: "space-y-1",
                                  attrs: { "data-id": _vm.panelId }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex items-center gap-2",
                                      attrs: { "data-id": _vm.panelId }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "Consecutive success"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-wrap items-center gap-1",
                                      attrs: { "data-id": _vm.panelId }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text:
                                            "Receive a recommendation only if the"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "session is successful for"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "font-bold",
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text:
                                            _vm.actionRecommendation
                                              .consecutive_success +
                                            " consecutive"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "font-bold",
                                        attrs: {
                                          "data-id": _vm.panelId,
                                          text: "session(s)."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                ]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12f3011c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f3011c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/databank/PanelDetails.vue
// module id = null
// module chunks = 